import { useMemo } from "react"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { TabulatedLayout } from "../../layouts/TabulatedLayout"

export function MobileModulePage(props) {
    const {
        className,
        defaultTab,
        paramKey,
        tabChangeCallback,
        tabsConfig,
        tabElement,
        ...otherProps
    } = props

    const {
        setParam,
    } = useUrlParams()
    const { getParam } = useUrlParams()
    const tabParam = getParam(paramKey)

    const tabValue = useMemo(() => {
        const tabIndex = tabsConfig.findIndex(tabConfig => tabConfig.id === tabParam)
        return tabIndex > -1 ? tabIndex : defaultTab || 0
    }, [defaultTab, tabParam, tabsConfig])

    const handleChange = (_, newValue) => {
        if (tabChangeCallback) {
            tabChangeCallback(tabsConfig[tabValue]?.id, tabsConfig[newValue]?.id)
        }
        setParam(paramKey, tabsConfig[newValue]?.id)
    }

    return (
        <TabulatedLayout
            className={className}
            handleChange={handleChange}
            tabsConfig={tabsConfig}
            tabElement={tabElement}
            value={tabValue}
            {...otherProps}
        />
    )
}

MobileModulePage.propTypes = {
    className: PropTypes.string,
    defaultTab: PropTypes.number,
    paramKey: PropTypes.string.isRequired,
    tabsConfig: PropTypes.arrayOf(PropTypes.shape({
        element: PropTypes.element,
        icon: PropTypes.element,
        id: PropTypes.string,
        label: PropTypes.string,

    }).isRequired),
}